export default "__VITE_ASSET__3EwYQVmz__"